import { h, ComponentType, createContext } from "preact";

import { MultiSelectItem } from "./types";

interface MultiSelectGroupContext {
    register(item: MultiSelectItem<unknown>): void;
    unregister(item: MultiSelectItem<unknown>): void;
    updateRegistry(item: MultiSelectItem<unknown>): void;
    toggleSelection(item: MultiSelectItem<unknown>): void;
}

const MultiSelectGroupContext = createContext<MultiSelectGroupContext>({
    register: () => null,
    unregister: () => null,
    updateRegistry: () => null,
    toggleSelection: () => null
});

interface WithMultiSelectGroupContextProps {
    multiSelectGroupContext?: MultiSelectGroupContext;
}

function withMultiSelectGroupContext<P>(WrappedComponent: ComponentType<P>) {
    return (props: Omit<P, "multiSelectGroupContext">) => (
        <MultiSelectGroupContext.Consumer>
            {context => <WrappedComponent {...(props as P)} multiSelectGroupContext={context}/>}
        </MultiSelectGroupContext.Consumer>
    );
}

export default MultiSelectGroupContext;
export { withMultiSelectGroupContext, WithMultiSelectGroupContextProps };
